import React from "react";
import "./Experiance.css";

const Experiance = () => {
  return (
    <div className="experiance" id="Experiance">
      <div className="achivement">
        <div className="circle">1+</div>
        <span>years</span>
        <span>Experiance</span>
      </div>
      <div className="achivement">
        <div className="circle">10+</div>
        <span>completed</span>
        <span>Projects</span>
      </div>
      <div className="achivement">
        <div className="circle">1+</div>
        <span>companies</span>
        <span>Works</span>
      </div>
    </div>
  );
};

export default Experiance;
